var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2906",
    "data-name": "Group 2906",
    transform: "translate(-131 -556)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1296",
    "data-name": "Rectangle 1296",
    width: 12,
    height: 12,
    transform: "translate(131 556)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M-2031.27-22.621V-24.06l4.442-4.443,1.409,1.467-4.413,4.414Zm5.155-6.713.759-.76s.142-.319.656.2.909.916.909.916.195.261,0,.421-.743.69-.743.69Z",
    transform: "translate(2164.487 588.406)",
    fill: "#009dce"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/edit_blue.084698b9219a1f6e92686a599898b196.svg";
export { ForwardRef as ReactComponent };